module.exports = __webpack_public_path__ + "assets/fonts/outbound.d54276e8.svg";